import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import DirectRequestFormDialog from '@/components/DirectRequestFormDialog/DirectRequestFormDialog';
import FloatingCTA from '@/components/FloatingCTA/FloatingCTA';
import Hero from '@/components/Hero/Hero';
import { useDirectRequestDialogContext } from '@/hooks/useDirectRequestDialog';
import { useMobileMediaQuery } from '@/hooks/useMobileMediaQuery';

const CategoryHeroVariant = ({ headline, pictures }) => {
  const [floatingCTA, setFloatingCTA] = useState(false);

  const {
    dialogOpen,
    openDialog,
    closeDialog,
  } = useDirectRequestDialogContext();
  const mobileMediaQuery = useMobileMediaQuery();

  const heroRef = useRef();

  useEffect(() => {
    const handleScroll = () => {
      if (heroRef.current) {
        setFloatingCTA(
          heroRef.current.getBoundingClientRect().bottom <
            (mobileMediaQuery ? 0 : 100)
        );
      }
    };
    window.addEventListener('scroll', handleScroll, true);

    return () => window.removeEventListener('scroll', handleScroll, true);
  }, [mobileMediaQuery]);

  return (
    <>
      <Box ref={heroRef}>
        <Hero headline={headline} pictures={pictures} />
      </Box>
      <DirectRequestFormDialog open={dialogOpen} closeDialog={closeDialog} />
      {floatingCTA && <FloatingCTA onClick={openDialog} />}
    </>
  );
};

CategoryHeroVariant.propTypes = {
  headline: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
  pictures: PropTypes.object,
};

export default CategoryHeroVariant;
